
<ion-header>
  <ion-toolbar class="header__title">
      <ion-title color="light">Customer Address</ion-title>
      <!-- <ion-buttons slot="end">
        <ion-button fill="clear" color="" (click)="add_address()">
          + Add Address
         </ion-button>
      </ion-buttons> -->
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- <div> -->
  <!-- <ion-content> -->
   
  <app-cus-address [customer_id]="db.Customer"></app-cus-address>
    <!-- <app-cus-address > </app-cus-address> -->

 <!-- <div class="container">
   <div class="address__container h-100">
     <div>
     
       <div class="address__lists"> 
         <ion-list class="address__mouse" *ngFor="let item of address_list;let i=index" (click)="selected_address = item">
           <div class="address__list" *ngFor="let address of item.address">
             <div (click)="select_customer(address)">
               <h5 class="name-title">{{address.first_name}} {{address.last_name}}</h5>
                 <p class="address">
                   {{address.address }}, {{address.city}} - {{address.zipcode}}<br>
                   {{address.state}}, {{address.country}} &ensp;&ensp;&ensp;<span *ngIf="address.phone">Contact: {{address.phone}}</span></p>
             </div>
 
              <div class="action__buttons">
                <div class="d__flex ion__button">
                  <ion-button class="edit__button" fill="clear" color="success" (click)="edit_address(address,i)"><ion-icon src="/assets/icons/edit.svg"></ion-icon> Edit</ion-button>
                  <ion-button class="delete__button" fill="clear" (click)="confirm_delete(address,i)"><ion-icon src="/assets/icons/delete.svg"></ion-icon> Delete</ion-button>
                </div>
              </div> 
           </div>
                   
         </ion-list>
         
       </div>
       
     </div>
   </div>
 </div> -->
 
</ion-content>

